import { ApiClient } from "#/shared/api/client";

function extractErrorMessage(error) {
  const data = error?.data;

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.join(", ");
  }

  if (typeof data?.error === "string" && data.error.length > 0) {
    return data.error;
  }

  if (typeof data === "string" && data.length > 0 && !data.trim().startsWith("<")) {
    return data;
  }

  if (error?.status) {
    return `Server responded with ${error.status}`;
  }

  return error?.message || "An error occurred. Please try again.";
}

class RsvpInviteApi extends ApiClient {
  transform(data) {
    return data;
  }

  async preview(previewUrl, formData) {
    try {
      return await this.post(previewUrl, formData);
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }

  async process(processUrl, payload) {
    try {
      return await this.post(processUrl, payload);
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }
}

let api;

export function createRsvpInviteApi() {
  api ??= new RsvpInviteApi();

  return api;
}
